export default "__VITE_ASSET__DIT0go6a__"